import React from 'react'
import { Collapse } from "antd";
import { Container } from './styles';

interface IEmbedCollapseProps {
  embedId: string;
}

const { Panel } = Collapse;

const EmbedCollapse: React.FC<IEmbedCollapseProps> = ({ embedId }) => (
  <Container>
    <Collapse className='collapse'>
      <Panel header="Caso queira fazer junto com a gente, assista ao vídeo" key="1">
        <iframe
          src={`https://www.youtube.com/embed/${embedId}`}
          frameBorder="0"
          className="styled-iframe"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </Panel>
    </Collapse>
  </Container>
);

export default EmbedCollapse
